'use strict';

import {element_exists} from "../functions";

export var fnDownloadTemplate = function () {

    const btn = '#btn-download-template';

    if (!element_exists(btn)) {
        return false;
    }
    $(btn).off('click').on('click', function (e) {
        e.preventDefault();
        window.open($(this).data('href'), '_blank');
    });
}